import AVText from 'src/components/elements/AVText';
import React from 'react';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import {Dimensions, Image, Platform, StyleSheet, View} from 'react-native';
import Localized from 'src/constants/AppStrings';
import {
  AnnouncementStylesDescriptor,
  CampusLocationListStylesDescriptor,
  ReferralDescriberData,
  RewardskDescriberData,
  RewardsLegacykDescriberData,
  SendSnackDescriberData,
} from 'src/components/elements/home/descriptors/campusComponents/DescriptorType';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import PointsIndicator from 'src/components/elements/rewards/PointsIndicator';
import {UserRewardsTierIcon} from 'src/components/img/svg/rewards';
import ShopIconPay from 'src/components/img/svg/ShopIconpay';
import RewardRedesignHome from 'src/components/img/svg/RewardRedesignHome';
import CoffeeIcon from 'src/components/img/svg/coffee/coffeeIcon';
import LocationMarkerErrorIcon from 'src/components/img/svg/LocationMarkerErrorIcon';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import Styles from 'src/components/Styles';
import ScanIcon from 'src/components/img/svg/ScanIcon';

const width = Dimensions.get('window').width;

export function getCampusLocationStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    recentLocationAddressText: {
      color: '#707070',
      fontSize: Styles.Fonts.f8,
      width: width - Styles.Spacing.m5 - Styles.Spacing.m4,
      textAlignVertical: 'center',
      fontWeight: '400',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    recentLocationViewLocationNameText: {
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '400',
      fontFamily: Styles.FontFamily.gothamRegular,
      textAlignVertical: 'center',
      width: width - Styles.Spacing.m5 - Styles.Spacing.m4,
      color: Styles.black,
      textTransform: 'capitalize',
    },
    locationListView: {
      margin: Styles.Spacing.m3,
      ...Styles.Style.shadow,
    },
    separator: {
      width: width - Styles.Spacing.m3 * 2 - 50,
      height: 1,
      backgroundColor: Styles.Colors.PayNew.neutralHuesBase09,
      marginLeft: 50,
    },
    locationDisplatText: {
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.PayNew.black01,
      fontWeight: '400',
    },
    locationDisplatSubText: {
      fontSize: 14,
      fontFamily: Styles.FontFamily.gothamRegular,
      color: Styles.Colors.PayNew.darkHuesBase04,
    },
    recentListborder: {
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    greetNameText: {
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '700',
      color: Styles.blackBase01,
      fontFamily: Styles.FontFamily.gothamRegular,
      marginRight: 8,
    },
    balanceText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontFamily: Styles.FontFamily.gothamRegular,
      fontWeight: '400',
      color: Styles.blackBase01,
      paddingBottom: Platform.OS === 'android' ? 4 : 0,
    },
  };
}

export function paymentComboIconColor() {
  return Styles.Colors.Aramark.primary;
}

export function snackViewDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  const {onSendASnackClick} = props;
  return (
    <React.Fragment>
      <View style={stylesCampus.headerView}>
        <AVText
          accessibilityRole="text"
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          accessibilityLabel={'Localized.Labels.gifting_title'}
          style={stylesCampus.giftTitleText}
          accessible={true}
          testID={'qa_Gifting_txt'}
          aria-label={`${Localized.Labels.gifting_title}, text`}
        >
          {Localized.Labels.gifting_title}
        </AVText>
      </View>
      <AVTouchableOpacity
        aria-label={
          Localized.Buttons.send_a_snack +
          ', ' +
          Localized.Labels
            .send_your_colleagues_tasty_snacks_to_brighten_their_day
        }
        accessible={true}
        accessibilityLabel={
          Localized.Buttons.send_a_snack +
          ', ' +
          Localized.Labels
            .send_your_colleagues_tasty_snacks_to_brighten_their_day
        }
        accessibilityHint="Double tap to navigate to the send a snack screen"
        accessibilityRole="button"
        role="button"
        onPress={onSendASnackClick}
        testID="qa_btn_SnackGift"
      >
        <View style={stylesCampus.container}>
          <View
            aria-label={'SnackIcon'}
            role="img"
            accessibilityRole="image"
            accessibilityLabel={'SnackIcon'}
          >
            <Image
              accessibilityLabel="Snack gift"
              accessibilityRole="image"
              role="img"
              accessible={true}
              aria-label="Snack gift"
              style={{width: 63, height: 56}}
              resizeMode="contain"
              source={require('../../../../img/aramarkSnackGift.gif')}
            />
          </View>
          <View style={stylesCampus.snackTitleView}>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Buttons.send_a_snack}, text`}
              style={stylesCampus.sendSnackTitle}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityLabel={Localized.Buttons.send_a_snack}
            >
              {Localized.Labels.send_a_snack_title}
            </AVText>

            <AVText
              accessibilityLabel={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              aria-label={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={stylesCampus.sendSnackDescription}
              accessibilityRole="text"
            >
              {
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getScanAndPayTile(): {[key: string]: any} {
  return {
    iconViewBackground: {
      backgroundColor: Styles.Colors.PayNew.neutralHuesBase12,
      width: 50,
      height: 50,
      margin: Styles.Spacing.m3,
    },
    titleText: {
      color: Styles.black,
      fontWeight: '700',
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.gothamRegular,
      paddingBottom: Styles.Spacing.m2,
    },
    nameText: {
      color: Styles.black,
      fontWeight: '400',
      fontSize: getLayoutDescriber().bodyFontSize(),
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    rowSpace: {
      marginVertical: Styles.Spacing.m2,
    },
    listContainer: {
      marginTop: Styles.Spacing.m3,
    },
    textView: {
      marginVertical: Styles.Spacing.m3,
    },
  };
}

export function infoIconPrimaryColor() {
  return Styles.Colors.PayNew.neutralHuesBase12;
}
export function infoIconInnerColor() {
  return Styles.Colors.Aramark.primary;
}

export function announcemnentButtonColor() {
  return Styles.Colors.Aramark.primary;
}

export function getAnnouncementStyles(): AnnouncementStylesDescriptor {
  return StyleSheet.create({
    container: {
      backgroundColor: Styles.Colors.PayNew.white01,
      marginTop: Styles.Spacing.m3 - 4,
      marginHorizontal: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m2 + 4,
      borderRadius: Styles.Spacing.m2,
      alignItems: 'left',
      justifyContent: 'flex-start',
      borderWidth: 1,
      borderColor: Styles.Colors.PayNew.neutralHuesBase09,
      ...Styles.Style.shadow,
    },
    titleText: {
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      width: '80%',
      fontWeight: '700',
      color: Styles.black,
      marginRight: Styles.Spacing.m3,
      marginLeft: Styles.Spacing.m3,
      textAlign: 'left',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    descriptionText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.gothamRegular,
    },
  });
}

export function getWidthImageAvailable() {
  return '75%';
}

export function getCampusLocationListStyles(): CampusLocationListStylesDescriptor {
  return StyleSheet.create({
    container: {
      marginTop: Styles.Spacing.m3,
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginBottom: Styles.Spacing.m3,
    },
    campusLocationListView: {
      width: '100%',
    },
    headerMargin: {
      marginLeft: Styles.Spacing.m3,
      marginTop: -(Styles.Spacing.m3 + Styles.Spacing.m2),
    },
    diningLocationLabel: {
      color: Styles.Colors.PayNew.black01,
      fontFamily: Styles.FontFamily.gothamRegular,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '700',
      flexWrap: 'wrap',
      width: '80%',
    },
  });
}

export function referralViewDescriptor(
  props: ReferralDescriberData,
  amtLocalised?: string,
): JSX.Element {
  const {onInviteClick, styles, amount, isSnackEnabled} = props;
  const desc = Localized.Labels.formatString(
    Localized.Labels.receive_redesign_cash_to_spend,
    amtLocalised,
  );
  const title = Localized.Labels.formatString(
    Localized.Labels.give_get_redesign,
    amtLocalised,
    amtLocalised,
  );
  return (
    <React.Fragment>
      {!isSnackEnabled && (
        <View style={styles.headerView}>
          <AVText
            accessibilityRole="text"
            style={stylesCampus.sendSnackTitle}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible={true}
            aria-label={`${Localized.Labels.recents}, text`}
            accessibilityLabel={Localized.Labels.recents}
          >
            {Localized.Labels.gifting_title}
          </AVText>
        </View>
      )}
      <AVTouchableOpacity
        accessible={true}
        onPress={onInviteClick}
        accessibilityLabel={[title, desc].join('. ')}
        accessibilityHint="Double tap to navigate to the Refferals screen"
        role="button"
        aria-label={[title, desc].join('. ')}
        accessibilityRole="button"
        testID="qa_btn_Refferals"
      >
        <View style={styles.container} nativeID="qa_btn_Refferals">
          <View
            role="img"
            accessibilityLabel={'grpreferralIcon'}
            accessibilityRole="image"
            aria-label={'grpreferralIcon'}
          >
            <GrpReferralRedesign
              width={63}
              height={56}
              gradColor1={Styles.Colors.Aramark.primary}
              gradColor2={Styles.Colors.Aramark.primary}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              aria-label={`${title}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityRole="text"
              style={stylesCampus.rewardTitle}
              accessibilityLabel={title as string}
            >
              {title}
            </AVText>

            <AVText
              accessibilityLabel={desc as string}
              aria-label={desc as string}
              accessibilityRole="text"
              style={stylesCampus.sendSnackDescription}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            >
              {desc}
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function rewardsViewDescriptor(
  props: RewardskDescriberData,
): JSX.Element {
  const {
    marketAccountPoints,
    onRewardsClick,
    styles,
    rewardTier,
    bgSize,
    tileHeight,
    productThresholds,
    maxPointValue,
    maxPointsLabel,
  } = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        activeOpacity={0.75}
        accessibilityLabel={Localized.Labels.pay_earn_enjoy}
        accessibilityHint="Press to navigate to rewards"
        style={{marginBottom: 20}}
        onPress={onRewardsClick}
        testID="qa_btn_RewardPoints"
      >
        <View
          style={[styles.container, {paddingHorizontal: Styles.Spacing.m3}]}
        >
          <View style={[styles.shadowWrapper, stylesCampus.rewardView]}>
            <UserRewardsTierIcon
              tierName={rewardTier?.tierName}
              size={bgSize}
              style={styles.tierIcon}
            />

            <PointsIndicator
              height={tileHeight - Styles.Spacing.m3 * 3}
              availablePoints={marketAccountPoints}
              thresholds={productThresholds}
              maxPointValue={maxPointValue}
              rewardedColor={Styles.Colors.Aramark.primary}
              maxPointValueLabel={maxPointsLabel}
            />

            <View style={styles.content}>
              <AVText style={[styles.payEarnEnjoy, stylesCampus.font]}>
                {Localized.Labels.pay_earn_enjoy}
              </AVText>

              <View style={styles.rewardStatus}>
                <AVText style={[styles.rewardStatustxt, stylesCampus.font]}>
                  {Localized.Labels.rewards_status}
                </AVText>

                <AVText style={[styles.currentTierName, stylesCampus.font]}>
                  {rewardTier?.tierName}
                </AVText>
              </View>
            </View>

            <ChevronRight
              color={Styles.Colors.PayNew.darkHuesBase04}
              style={styles.chevron}
            />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}

export function rewardsLegacyViewDescriptor(
  props: RewardsLegacykDescriberData,
): JSX.Element {
  const {onRewardsClick, styles, stat} = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        aria-label={[Localized.Labels.rewards, stat].join('. ')}
        accessible={true}
        accessibilityLabel={[Localized.Labels.rewards, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the rewards screen"
        accessibilityRole="button"
        role="button"
        onPress={onRewardsClick}
      >
        <View style={styles.container}>
          <View accessibilityLabel={'RewardsIcon'}>
            <RewardRedesignHome
              color={Styles.Colors.Aramark.primary}
              backgroundColor={Styles.Colors.PayNew.neutralHuesBase12}
            />
          </View>
          <View style={stylesCampus.rewardTitleView}>
            <AVText
              accessibilityRole="text"
              style={stylesCampus.rewardTitle}
              accessibilityLabel={Localized.Labels.rewards}
              aria-label={`${Localized.Labels.rewards}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
            >
              {Localized.Labels.rewards}
            </AVText>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Labels.rewards} ${stat}`}
              accessibilityLabel={`${Localized.Labels.rewards} ${stat}`}
              style={stylesCampus.rewardStat}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
            >
              {stat}
            </AVText>
          </View>
          <View style={{justifyContent: 'center'}}>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getEngagementCarouselPaginationActiveDotColor(): string {
  return Styles.Colors.Aramark.primary;
}

export function locationListIcon(): JSX.Element {
  return <ShopIconPay size={25} color={Styles.Colors.PayNew.black01} />;
}

export function RecentlocationListIcon(): JSX.Element {
  return (
    <View style={{paddingLeft: 8}}>
      <ShopIconPay size={25} color={Styles.Colors.PayNew.black01} />
    </View>
  );
}

export function announcementBtnFont(): string {
  return Styles.FontFamily.gothamRegular;
}

export function getScanAndPayTileIcon(coffeMachineType: boolean): JSX.Element {
  if (coffeMachineType) {
    return (
      <CoffeeIcon
        width={28}
        height={28}
        viewBox={'0 0 24 24'}
        color={Styles.Colors.Aramark.primary}
      />
    );
  } else {
    return <ScanIcon color={Styles.Colors.Aramark.primary} />;
  }
}

export function getVendingTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    headerText: {
      color: Styles.black,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '700',
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    nameText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    vendingSmatxt: {
      color: Styles.black,
      fontSize: Styles.Fonts.f9 - 6,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.gothamRegular,
      fontStyle: 'italic',
      marginTop: 16,
      paddingHorizontal: 16,
    },
    buttonText: {
      color: Styles.Colors.Aramark.primary,
      backgroundColor: 'transparent',
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '600',
      fontStyle: 'normal',
    },
  };
}

export function getDiningTile(): {
  [key: string]: {[index: string]: number | string};
} {
  const windowWidth = Dimensions.get('window').width;
  return {
    nameText: {
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      marginTop: Styles.Spacing.m2,
      paddingLeft: Styles.Spacing.m1,
      fontFamily: Styles.FontFamily.gothamRegular,
      width: windowWidth - Styles.Spacing.m4 - Styles.Spacing.m3,
    },
  };
}

export function getQRCodeTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    quickFundText: {},
    balanceText: {},
    balanceValue: {},
  };
}

function getLocationMarkerErrorIcon() {
  return (
    <View style={stylesCampus.locationErrorIconView}>
      <LocationMarkerErrorIcon />
    </View>
  );
}

export function getScanAndPayMismatchLocationError(): JSX.Element {
  return (
    <View style={stylesCampus.locationErrorContainer}>
      {getLocationMarkerErrorIcon()}
      <AVText
        style={stylesCampus.locationErrorDescription}
        accessibilityElementsHidden={true}
        accessibilityLabel={
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations
        }
        accessibilityRole="text"
        aria-label={`${Localized.Labels.your_account_balance_is_not_valid_at_some_locations}, text`}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {Localized.Labels.your_account_balance_is_not_valid_at_some_locations}
      </AVText>
    </View>
  );
}

export function getTileButton(
  _buttonText: string,
  _handleClick: () => void,
  _disabled?: boolean,
): JSX.Element {
  return null;
}

const stylesCampus = StyleSheet.create({
  locationErrorContainer: {
    alignItems: 'center',
    height: Styles.Heights.h7 * 2,
    width: '100%',
    justifyContent: 'center',
  },
  locationErrorDescription: {
    color: Styles.black,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '400',
    fontFamily: Styles.FontFamily.gothamRegular,
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
  container: {
    flexDirection: 'row',
    backgroundColor: Styles.white,
    margin: Styles.Spacing.m3,
    marginBottom: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    ...Styles.Style.shadow,
    minHeight: Styles.MinTouchableArea,
  },
  headerView: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  giftTitleText: {
    fontWeight: '700',
    paddingLeft: 16,
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontFamily: Styles.FontFamily.gothamRegular,
    color: Styles.black,
  },
  sendSnackTitle: {
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontWeight: '700',
    color: Styles.black,
    fontFamily: Styles.FontFamily.gothamRegular,
  },
  sendSnackDescription: {
    color: Styles.black,
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontFamily: Styles.FontFamily.gothamRegular,
    fontWeight: '400',
  },
  rewardTitleView: {
    flex: 1,
    margin: Styles.Spacing.m3,
  },
  rewardTitle: {
    color: Styles.black,
    fontFamily: Styles.FontFamily.gothamRegular,
    fontSize: getLayoutDescriber().subHeaderFontSize(),
    fontWeight: '700',
    marginBottom: Styles.Spacing.m1,
  },
  rewardStat: {
    fontFamily: Styles.FontFamily.gothamRegular,
    fontWeight: '700',
    color: Styles.black,
    fontSize: getLayoutDescriber().subHeaderFontSize(),
  },
  font: {
    fontFamily: Styles.FontFamily.gothamRegular,
  },
  locationErrorIconView: {
    justifyContent: 'center',
    alignItems: 'center',
    width: Styles.Heights.h5,
    height: Styles.Heights.h5,
    marginBottom: Styles.Spacing.m2,
  },
  snackTitleView: {
    flex: 1,
    margin: Styles.Spacing.m3,
  },
  rewardView: {
    borderWidth: 1,
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
  },
});

export function getNoNearbyLocationsComponent(): JSX.Element {
  return null;
}

export default {
  getCampusLocationStyles,
  snackViewDescriptor,
  getScanAndPayTile,
  announcementBtnFont,
  infoIconPrimaryColor,
  infoIconInnerColor,
  announcemnentButtonColor,
  getAnnouncementStyles,
  getWidthImageAvailable,
  rewardsLegacyViewDescriptor,
  getCampusLocationListStyles,
  referralViewDescriptor,
  rewardsViewDescriptor,
  RecentlocationListIcon,
  getEngagementCarouselPaginationActiveDotColor,
  locationListIcon,
  getScanAndPayTileIcon,
  getVendingTile,
  getDiningTile,
  getQRCodeTile,
  getScanAndPayMismatchLocationError,
  getTileButton,
  getNoNearbyLocationsComponent,
  paymentComboIconColor,
};
